import {Component, Input, OnInit, TemplateRef, ViewChild, Output, EventEmitter} from '@angular/core';
import {NgbModal, NgbModalOptions, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {ToastrService} from "ngx-toastr";
import feather from 'feather-icons';
import {TresorerieService} from '../../../../../services/tresorerie/tresorerie.service';
import {Tresorerie} from '../../../../../models/Tresorerie/Tresorerie';
import {CategorieTresorerie} from '../../../../../models/Tresorerie/CategorieTresorerie';

@Component({
    selector: 'app-add-depense',
    templateUrl: './add-depense.component.html',
    styleUrls: ['./add-depense.component.scss']
})
export class AddDepenseComponent implements OnInit {

    @Input() data: any = null;
    @Input() soldeType: string = 'secondaire';
    @Output() depenseCreated = new EventEmitter<void>();
    @ViewChild('modalLG') modalTemplate!: TemplateRef<any>;

    formData: any = {
        methode_paiement: '',
        categorie: '',
        montant: '',
        date_reglement: '',
        note: ''
    };

    categories: CategorieTresorerie[] = [];
    stationId: number = 0;
    userId: number = 0;
    isLoading = false;
    currentStep = 1;
    private modalRef!: NgbModalRef;

    constructor(
        private modalService: NgbModal,
        private toastr: ToastrService,
        private tresorerieService: TresorerieService
    ) {}

    ngOnInit(): void {
        this.loadUserData();
        this.loadCategories();
    }

    ngAfterViewInit(): void {
        feather.replace();
    }

    private loadUserData(): void {
        try {
            const userJson = localStorage.getItem('currentUser');
            if (userJson) {
                const user = JSON.parse(userJson);
                this.userId = user?.id || 0;
                const station = user?.stations?.[0];
                this.stationId = station?.id ? Number(station.id) : 0;
            }
        } catch (error) {
            console.error('Erreur lors de la récupération des données utilisateur:', error);
        }
    }

    private loadCategories(): void {
        if (!this.stationId) {
            console.warn('⚠️ [AddDepenseComponent] stationId manquant, impossible de charger les catégories.');
            this.categories = [];
            return;
        }
        this.tresorerieService.getCategories(this.stationId).subscribe({
            next: (categoriesArray: CategorieTresorerie[]) => {
                this.categories = categoriesArray || [];
                if (this.categories.length === 0) {
                    console.warn('⚠️ [AddDepenseComponent] Aucune catégorie reçue. Vérifiez que l’API GET /api/tresorerie/categories existe et retourne des données.');
                } else {
                    console.log('✅ [AddDepenseComponent] Catégories chargées:', this.categories.length, this.categories);
                }
            },
            error: (error) => {
                console.error('❌ [AddDepenseComponent] Erreur lors du chargement des catégories:', error);
                this.toastr.error('Erreur lors du chargement des catégories. Vérifiez l’URL et que le module trésorerie est démarré.', 'Erreur');
                this.categories = [];
            }
        });
    }

    openModal() {
        this.resetForm();
        this.loadCategories();
        const options: NgbModalOptions = {
            centered: true,
            backdrop: 'static',
            keyboard: true,
            windowClass: 'custom-modal'
        };
        this.modalRef = this.modalService.open(this.modalTemplate, options);
    }

    private resetForm() {
        this.currentStep = 1;
        this.formData = {
            methode_paiement: '',
            categorie: '',
            montant: '',
            date_reglement: new Date().toISOString().split('T')[0],
            note: ''
        };
    }

    nextStep() {
        if (this.currentStep === 1 && !this.formData.methode_paiement) {
            this.toastr.error('Veuillez sélectionner une méthode de paiement.', 'Erreur');
            return;
        }
        if (this.currentStep === 2) {
            if (!this.formData.categorie) {
                this.toastr.error('Veuillez sélectionner une catégorie.', 'Erreur');
                return;
            }
            if (!this.formData.montant || parseFloat(this.formData.montant) <= 0) {
                this.toastr.error('Le montant est requis et doit être supérieur à 0.', 'Erreur');
                return;
            }
        }
        if (this.currentStep === 3) {
            if (!this.formData.date_reglement) {
                this.toastr.error('La date de règlement est requise.', 'Erreur');
                return;
            }
        }
        if (this.currentStep < 4) this.currentStep++;
    }

    prevStep() {
        if (this.currentStep > 1) this.currentStep--;
    }

    resetStepper() {
        this.currentStep = 1;
    }

    validateDepense() {
        if (!this.validateForm()) {
            return;
        }

        this.isLoading = true;
        let methodePaiementBackend: 'espece' | 'cheque' | 'virement' | 'traite' | 'retenue' = this.formData.methode_paiement as any;
        if (this.formData.methode_paiement === 'retenue') {
            methodePaiementBackend = 'retenue' as any;
        }

        const operation: Tresorerie = {
            date_operation: this.formData.date_reglement || new Date().toISOString().split('T')[0],
            type_operation: 'depense',
            type_paiement: 'debit',
            montant: this.formData.montant.toString(),
            montant_ttc: this.formData.montant.toString(),
            methode_paiement: methodePaiementBackend,
            categorie_id: this.formData.categorie ? parseInt(this.formData.categorie) : null,
            note: this.formData.note || null,
            description: this.formData.note || null,
            solde_type: this.soldeType,
            user_id: this.userId,
            station_id: this.stationId,
            statut: 'actif',
            document_id: null,
            paiement_id: null
        };

        this.tresorerieService.createTresorerie(operation).subscribe({
            next: (result) => {
                if (result && (result as any).data && (result as any).data.tresorerie) {
                    const tresorerie = (result as any).data.tresorerie;
                    console.log('🔍 [AddDepenseComponent] Vérification de la mise à jour du solde:');
                    console.log('   - methode_paiement:', tresorerie.methode_paiement);
                    console.log('   - montant:', tresorerie.montant);
                    console.log('   - solde_type:', tresorerie.solde_type);
                    console.log('   ⚠️  Le backend doit mettre à jour montant_' + tresorerie.methode_paiement + ' dans le solde ' + tresorerie.solde_type);
                }
                if (result && (result as any).data && (result as any).data.tresorerie) {
                    const tresorerie = (result as any).data.tresorerie;
                    console.log('🔍 [AddDepenseComponent] Vérification de la mise à jour du solde:');
                    console.log('   - methode_paiement:', tresorerie.methode_paiement);
                    console.log('   - montant:', tresorerie.montant);
                    console.log('   - solde_type:', tresorerie.solde_type);
                    console.log('   ⚠️  ATTENTION: Le backend doit mettre à jour montant_' + tresorerie.methode_paiement + ' dans le solde ' + tresorerie.solde_type);
                    console.log('   ⚠️  Si montant_' + tresorerie.methode_paiement + ' reste à 0 après rechargement, c\'est un problème backend.');
                }
                console.log('✅ [AddDepenseComponent] ═══════════════════════════════════════════════════════');
                this.toastr.success('Dépense ajoutée avec succès.', 'Succès');
                this.modalRef.close();
                this.depenseCreated.emit();
                this.isLoading = false;
            },
            error: (error) => {
                console.error('❌ [AddDepenseComponent] ═══════════════════════════════════════════════════════');
                console.error('❌ [AddDepenseComponent] Erreur lors de la création de la dépense:');
                console.error('❌ [AddDepenseComponent] Erreur (objet):', error);
                console.error('❌ [AddDepenseComponent] Erreur (JSON):', JSON.stringify(error, null, 2));
                if (error.error) {
                    console.error('❌ [AddDepenseComponent] Détails de l\'erreur (error.error):', error.error);
                    console.error('❌ [AddDepenseComponent] Détails de l\'erreur (error.error JSON):', JSON.stringify(error.error, null, 2));
                }
                if (error.message) {
                    console.error('❌ [AddDepenseComponent] Message d\'erreur:', error.message);
                }
                console.error('❌ [AddDepenseComponent] ═══════════════════════════════════════════════════════');
                this.toastr.error('Erreur lors de l\'enregistrement de la dépense.', 'Erreur');
                this.isLoading = false;
            }
        });
    }

    private validateForm(): boolean {
        if (!this.formData.methode_paiement) {
            this.toastr.error('La méthode de paiement est requise.', 'Erreur');
            return false;
        }
        if (!this.formData.categorie) {
            this.toastr.error('La catégorie est requise.', 'Erreur');
            return false;
        }
        if (!this.formData.montant || parseFloat(this.formData.montant) <= 0) {
            this.toastr.error('Le montant est requis et doit être supérieur à 0.', 'Erreur');
            return false;
        }
        if (!this.formData.date_reglement) {
            this.toastr.error('La date de règlement est requise.', 'Erreur');
            return false;
        }
        return true;
    }
}
